angular
  .module("AccountingBoxApp")
  .controller("VendorsMasterDetailCtrl", function(
    $scope,
    $location,
    $filter,
    $transition$,
    $state,
    Vendor,
    vendors,
    $rootScope
  ) {
    var vm = this;

    vm.vendors = vendors;
    vm.type = "general";

    vm.navigateToFirst = function() {
      if (vm.vendors.length > 0) {
        var vendorId = vm.vendors[0].id;
        $state.go("app.bookkeeper.vendors.edit", { id: vendorId });
      }
    };

    if ($state.current.name === "app.bookkeeper.vendors") {
      vm.navigateToFirst();
    }

    vm.isActive = function(contact) {
      return $transition$.params().id === contact.id;
    };

    vm.reload = function() {
      vm.checkedVendorIds = [];
      return Vendor.find({
        filter: {
          order: "name ASC",
          fields: {
            id: true,
            name: true,
            type: true,
            website: true,
            address: true
          }
        }
      }).$promise.then(function(vendors) {
        vm.vendors = vendors;
        setTimeout(() => {
          $scope.$apply();
          $scope.$broadcast('vsRepeatTrigger');
        }, 500);
        $scope.$apply();
        $scope.$broadcast('vsRepeatTrigger');
      });
    };

    vm.checkedVendorIds = [];

    vm.checked = function(vendorId) {
      return vm.checkedVendorIds.includes(vendorId);
    };

    vm.merge = function() {
      if (!$rootScope.isAdmin()) return;
      Vendor.merge({ ids: vm.checkedVendorIds }).$promise.then(function() {
        vm.editVendor({ id: vm.checkedVendorIds[0] });
        vm.reload();
      });
    };

    vm.editVendor = function(vendor) {
      $state.go(
        "app.bookkeeper.vendors.edit",
        { id: vendor.id },
        { reload: "app.bookkeeper.vendors.edit" }
      );
    };

    vm.toggleVendor = function(vendorId) {
      if (vm.checked(vendorId)) {
        vm.checkedVendorIds = vm.checkedVendorIds.filter(function(id) {
          return id !== vendorId;
        });
      } else {
        vm.checkedVendorIds.push(vendorId);
      }
      console.log("toggleVendor", vm.checkedVendorIds);
    };

    vm.reload();

    vm.handleSave = function(vendor) {
      vendor
        .$save()
        .then(vm.reload)
        .then(function() {
          vm.editVendor({ id: vendor.id });
        })
        .then(function() {
          $("body")
            .pgNotification({
              message: "Leverancier opgeslagen",
              type: "success",
              style: "flip"
            })
            .show();
        })
        .catch(function(response) {
          window.swal("Opslaan mislukt", response.data.error.message, "error");
        });
    };

    vm.handleDelete = function(vendor) {
      Vendor.deleteById({
        id: vendor.id
      })
        .$promise.then(function() {
          vm.reload().then(function() {
            setTimeout(vm.navigateToFirst, 500); //delay for modal backdrop issue
          });
        })
        .catch(function(response) {
          window.swal(
            "Verwijderen mislukt",
            response.data.error.message,
            "error"
          );
        });
    };
  });
